<app-summary-field [label]="label">
    <app-date-label [date]="date"></app-date-label>
</app-summary-field>
